
import React from "react";


const PreLoader = ()=>{
    return(<div>
        <h1 style={{textAlign: 'center', }}> please wait...</h1>
    </div>)
}

export default PreLoader;